import React, { forwardRef, RefAttributes } from "react"
import styles from "./styles.module.scss"
import { Card, CardProps, Tag } from "antd"
import moment from "moment"
import { IEvent } from "pages/events/types"
import { ReactComponent as AvailableSeatsIcon } from "assets/icons/available_seats.svg"
import { ReactComponent as MaximumSeatsIcon } from "assets/icons/max_seats.svg"

import { useTranslation } from "react-i18next"

interface Props extends CardProps {
  item: IEvent
  onButtonClick: () => void
  disabled?: boolean
}

const EventOverview = forwardRef<HTMLDivElement, Props>(
  (
    {
      item: {
        start_date,
        start_hour,
        end_hour,
        name,
        available_seats,
        displayed_status,
        max_participants,
        place,
        status,
        activity_room,
      },
      onButtonClick,
      disabled,
    },
    ref
  ) => {
    const { t } = useTranslation()

    return (
      <Card
        ref={ref}
        actions={[
          <div>
            {available_seats}
            <AvailableSeatsIcon style={{ marginLeft: "var(--size-2)" }} />
          </div>,
          <div>
            {max_participants}
            <MaximumSeatsIcon style={{ marginLeft: "var(--size-2)" }} />
          </div>,
          <Tag color={status === "execution" ? "green" : "yellow"}>
            {displayed_status}
          </Tag>,
        ]}
        onClick={() => (disabled ? null : onButtonClick())}
        hoverable
        className={styles.eventCard}
      >
        <div className={styles.header}>
          <div className={styles.headerDate}>
            <p className={styles.day}>
              {t(
                `date.days.long.${moment(start_date)
                  .locale("en")
                  .format("dddd")}`
              )}
            </p>
            <p className={styles.dayNumber}>
              {moment(start_date).format("DD")}
            </p>
            <p className={styles.month}>
              {t(
                `date.months.short.${moment(start_date)
                  .locale("en")
                  .format("MMMM")}`
              )}
            </p>
          </div>
          <div className={styles.titleContainer}>
            <div>
              <div>
                <p>{name}</p>
                <p>
                  {start_hour}
                  {" - "}
                  {end_hour}
                </p>
              </div>
            </div>
            <p>{place?.name ?? activity_room?.name}</p>
          </div>
        </div>
      </Card>
    )
  }
)

export default EventOverview
